export const WHATSAPP_NUMBER = "2349040337331";
export const WHATSAPP_MESSAGE = "Hello CardBarter, I want to trade with you";
export const WHATSAPP_URL = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
